import { render, staticRenderFns } from "./IframeTest.vue?vue&type=template&id=6e76f503&"
import script from "./IframeTest.vue?vue&type=script&lang=js&"
export * from "./IframeTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./IframeTest.vue?vue&type=custom&index=0&blockType=header"
if (typeof block0 === 'function') block0(component)

export default component.exports